/**
 * features that were available before module script tags:
 * chrome 61
 * edge 16
 * safari 11
 * firefox 60
 * https://caniuse.com/es6-module
 */

import 'mdn-polyfills/Node.prototype.append';
import 'mdn-polyfills/Node.prototype.prepend'; // edge 17 (one version after module)
import 'mdn-polyfills/String.prototype.padStart';
import 'mdn-polyfills/Array.prototype.findIndex';
